import { makeStyles } from "tss-react/mui-compat"
import moment from "moment-timezone"
import React, { useMemo } from "react"

const useStyles = makeStyles()(
  (theme) => ({
    container: {
      position: "relative",
      "& > div": {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        width: 90,
        height: 32,
        border: `1px solid ${theme.palette.gray.main}`,
        borderRadius: 10,

        background: theme.palette.gray.lightest,
        color: theme.palette.gray.darkest,

        ...theme.fonts.lato700,
        fontSize: 14,
        lineHeight: "22px",

        transition: "background-color 250ms ease-out, scale 150ms linear, color 50ms ease",
        cursor: "pointer",
        userSelect: "none",

        "&:hover": {
          backgroundColor: theme.palette.primary.light,
        },
        "&:active": {
          transform: "scale(0.965)",
        },
      },

      "& > input:focus + div": {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.gray.darkest,
        outlineColor: "initial",
        outlineStyle: "initial",
        outlineWidth: "initial",
      },
      "& > input:active + div": {
        transform: "scale(0.965)",
      },

      "& > input:checked:focus + div": {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.gray.darkest,
        outlineColor: "initial",
        outlineStyle: "initial",
        outlineWidth: "initial",
      },

      "& > input:checked + div": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.gray.lightest,
        border: `1px solid ${theme.palette.primary.main}`,

        "&:hover": {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.gray.darkest,
        },
      },
    },
    input: {
      // hiding input
      opacity: 0,
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: "100%",
      height: "100%",
      margin: 0,
    },
  })
)

interface TimePillProps {
  date: Date | moment.Moment | number
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  isChecked: boolean
}

export const TimePill = (props: TimePillProps) => {
  const { date, onChange, isChecked } = props
  const { classes } = useStyles()

  const dateToDisplay = useMemo(() => moment(date).format("LT"), [date])

  return (
    <label className={classes.container}>
      <input
        tabIndex={0}
        className={classes.input}
        type="radio"
        onChange={onChange}
        checked={isChecked}
        value={date.toString()}
      />
      <div>{dateToDisplay}</div>
    </label>
  )
}
